module.exports = __webpack_public_path__ + "media/images/products/vip-background-desktop-aefc397ec92d8af16043918b2cd05326.png";